import { removeEnumUnderscore } from "../../../../utils/helpers";
import {
    IAddendumDetails,
    SessionLocations,
} from "../../../../modules/notes/types/notes.types";
import { NO_SHOW_NOTE_MED_LABELS } from "../../../../utils/constants";
import NoteContentItem from "../NoteContentItem/NoteContentItem";

interface ViewNoShowNoteMedProps {
    noteContent: {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        [key: string]: any;
    };
    fieldAddendums: {
        [key: string]: IAddendumDetails[];
    } | null;
}

export default function ViewNoShowNoteMed({
    noteContent,
    fieldAddendums,
}: ViewNoShowNoteMedProps) {
    return (
        <>
            <NoteContentItem
                headerText={NO_SHOW_NOTE_MED_LABELS.session_location}
                fieldId="session_location"
                addendums={fieldAddendums?.session_location}
                content={
                    noteContent.session_location
                        ? removeEnumUnderscore(noteContent.session_location)
                        : "--"
                }
            />
            {noteContent.session_location === SessionLocations.Telehealth && (
                <>
                    <NoteContentItem
                        headerText={
                            NO_SHOW_NOTE_MED_LABELS.location_of_the_client
                        }
                        fieldId="location_of_the_client"
                        addendums={fieldAddendums?.location_of_the_client}
                        content={
                            noteContent.location_of_the_client
                                ? removeEnumUnderscore(
                                      noteContent.location_of_the_client
                                  )
                                : "--"
                        }
                    />
                    {noteContent.location_of_the_client === "other" && (
                        <NoteContentItem
                            headerText={
                                NO_SHOW_NOTE_MED_LABELS.other_location_of_the_client
                            }
                            fieldId="other_location_of_the_client"
                            addendums={
                                fieldAddendums?.other_location_of_the_client
                            }
                            content={
                                noteContent.other_location_of_the_client || "--"
                            }
                        />
                    )}
                    <NoteContentItem
                        headerText={
                            NO_SHOW_NOTE_MED_LABELS.location_of_the_provider
                        }
                        fieldId="location_of_the_provider"
                        addendums={fieldAddendums?.location_of_the_provider}
                        content={
                            noteContent.location_of_the_provider
                                ? removeEnumUnderscore(
                                      noteContent.location_of_the_provider
                                  )
                                : "--"
                        }
                    />
                    {noteContent.location_of_the_provider === "other" && (
                        <NoteContentItem
                            headerText={
                                NO_SHOW_NOTE_MED_LABELS.other_location_of_the_provider
                            }
                            fieldId="other_location_of_the_provider"
                            addendums={
                                fieldAddendums?.other_location_of_the_provider
                            }
                            content={
                                noteContent.other_location_of_the_provider ||
                                "--"
                            }
                        />
                    )}
                    <NoteContentItem
                        headerText={
                            NO_SHOW_NOTE_MED_LABELS.consent_was_received_for_the_teletherapy_session
                        }
                        fieldId="consent_was_received_for_the_teletherapy_session"
                        addendums={
                            fieldAddendums?.consent_was_received_for_the_teletherapy_session
                        }
                        content={
                            noteContent.consent_was_received_for_the_teletherapy_session
                                ? "Yes"
                                : "No"
                        }
                    />
                    <NoteContentItem
                        headerText={
                            NO_SHOW_NOTE_MED_LABELS.the_session_was_conducted_via_video
                        }
                        fieldId="the_session_was_conducted_via_video"
                        addendums={
                            fieldAddendums?.the_session_was_conducted_via_video
                        }
                        content={
                            noteContent.the_session_was_conducted_via_video
                                ? "Yes"
                                : "No"
                        }
                    />
                </>
            )}

            <NoteContentItem
                headerText={
                    NO_SHOW_NOTE_MED_LABELS.reason_provided_by_client_and_when_notice_was_given
                }
                fieldId="reason_provided_by_client_and_when_notice_was_given"
                addendums={
                    fieldAddendums?.reason_provided_by_client_and_when_notice_was_given
                }
                content={String(
                    noteContent.reason_provided_by_client_and_when_notice_was_given ||
                        "--"
                )}
            />
        </>
    );
}
